/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
let signals = [
    {
        "type": "EXEC_STATUS",
        "description": "Execution Status",
        "parameters": [{
            "name": "status",
            "value": "multiple",
            "description": [],
            "use" : true,
            "values" : [
                {
                    "value": "Completed",
                    "annotation" : "Completed"
                }, {
                    "value" : "Aborted",
                    "annotation" : "Aborted"
                }
            ],
            "default_value" : ["Completed"]
        }]
    }, 
    {
        "type": "EXEC_DURATION",
        "description": "Execution Duration",
        "parameters": [{
            "name": "bucket_id",
            "value": "multiple",
            "description": [
                "1: Less than 1 minute",
                "2: 1 minute - 15 minutes",
                "3: 15 minutes - 30 minutes",
                "4: 30 minutes - 1 hour",
                "5: 1 hour - 0.5 day",
                "6: 0.5 day - 1 day",
                "7: 1 day - 1 week",
                "8: 1 week - 1 month",
                "9: More than 1 month"
            ],
            "use" : false,
            "default_value" : []
        }, {
            "name": "statistics",
            "value": "single",
            "description": [
                "buckets",
                "average",
                "90 percentile",
                "median"
            ],
            "use" : true,
            "values" : [
                {
                    "value" : "average",
                    "annotation" : "Average"
                }, {
                    "value": "90 percentile",
                    "annotation" : "90 Percentile"
                }, {
                    "value" : "median",
                    "annotation" : "Median"
                }
            ],
            "default_value" : "90 percentile"
        }]
    }, 
    {
        "type": "INVOKE_FREQ",
        "description": "Invocation Frequency",
        "parameters": []
    }, 
    {
        "type": "NUM_OF_MSGS",
        "description": "Number of Messages",
        "parameters": [{
            "name": "operation",
            "value": "multiple",
            "description": [],
            "use" : true,
            "values" : [
                {
                  "value": "Recommend",
                  "annotation": "Recommender"
                },
                {
                  "value": "Classify",
                  "annotation": "Classifier",
                },
                {
                  "value": "TopicModel",
                  "annotation": "Theme Discovery",
                },
                {
                  "value": "ImageToText",
                  "annotation": "Summarizer",
                },
                {
                  "value": "LangDetect",
                  "annotation": "Language Detector",
                },
                {
                  "value": "NER",
                  "annotation": "Contextual Identity Extractor"
                }
            ],
            "default_value" : ["Recommend", "Classify", "TopicModel", "ImageToText", "LangDetect", "NER"]
        }]
    },
    {
      "type": "NUM_OF_MSGS_IU_LEVEL",
      "description": "Number of Messages",
      "parameters": [{
          "name": "operation",
          "value": "multiple",
          "description": [],
          "use" : true,
          "values" : [
              {
                "value": "Recommend",
                "annotation": "Recommender"
              },
              {
                "value": "Classify",
                "annotation": "Classifier",
              },
              {
                "value": "TopicModel",
                "annotation": "Theme Discovery",
              },
              {
                "value": "ImageToText",
                "annotation": "Summarizer",
              },
              {
                "value": "LangDetect",
                "annotation": "Language Detector",
              },
              {
                "value": "NER",
                "annotation": "Contextual Identity Extractor"
              }
          ],
          "default_value" : ["Recommend", "Classify", "TopicModel", "ImageToText", "LangDetect", "NER"]
      }]
    },
    {
        "type": "NUM_QUERIES",
        "description": "Number of Queries by Operation",
        "parameters": [{
            "name": "operation",
            "value": "multiple",
            "description": [],
            "use" : true,
            "values" : [
                {
                  "value": "Recommend",
                  "annotation": "Recommender"
                },
                {
                  "value": "Classify",
                  "annotation": "Classifier",
                },
                {
                  "value": "TopicModel",
                  "annotation": "Theme Discovery",
                },
                {
                  "value": "ImageToText",
                  "annotation": "Summarizer",
                },
                {
                  "value": "LangDetect",
                  "annotation": "Language Detector",
                },
                {
                  "value": "NER",
                  "annotation": "Contextual Identity Extractor"
                }
            ],
            "default_value" : ["Recommend", "Classify", "TopicModel", "ImageToText", "LangDetect", "NER"]
        }]
    }
]

export default signals